import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../auth.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false
})
export class LoginComponent implements OnInit {

  reason: string | null = null;
  readonly publicSiteUrl = environment.publicSiteUrl;
  readonly publicSiteHost = new URL(environment.publicSiteUrl).host;

  constructor(private authService: AuthService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.reason = this.route.snapshot.queryParamMap.get('reason');
  }

  get bannerMessage(): string {
    switch (this.reason) {
      case 'loggedout': return 'Vous avez été déconnecté.';
      case 'cancelled': return 'Connexion annulée.';
      case 'expired': return 'Votre session a expiré, veuillez vous reconnecter.';
      default: return '';
    }
  }

  get bannerClass(): string {
    switch (this.reason) {
      case 'loggedout': return 'rounded-lg bg-blue-50 border border-blue-200 px-4 py-3 text-blue-800';
      case 'cancelled': return 'rounded-lg bg-yellow-50 border border-yellow-200 px-4 py-3 text-yellow-800';
      case 'expired': return 'rounded-lg bg-orange-50 border border-orange-200 px-4 py-3 text-orange-800';
      default: return '';
    }
  }

  onLogin(): void {
    this.authService.login();
  }
}
